import styled, { css } from 'styled-components';

const shouldStopRight = css`
    border-bottom-right-radius: 24px;
    border-top-right-radius: 24px;
    right: auto;
    width: calc(50% + 24px);
`;

const shouldStopLeft = css`
    border-bottom-left-radius: 24px;
    border-top-left-radius: 24px;
    left: auto;
    width: calc(50% + 24px);
`;

const shouldStopBoth = css`
    width: 48px;
`;

export const DayRange = styled.div<{ $shouldStopLeft?: boolean; $shouldStopRight?: boolean }>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    ${({ $shouldStopRight }) => $shouldStopRight && shouldStopRight}
    ${({ $shouldStopLeft }) => $shouldStopLeft && shouldStopLeft}

    ${({ $shouldStopLeft, $shouldStopRight }) => $shouldStopLeft && $shouldStopRight && shouldStopBoth}
`;
